import { Box } from '@mui/material'

import * as OrderTexts from '../../../../../../intl'
import { form } from '../../../formState'
import { Props } from '../typings'

export function Duration(props: Props) {
  const { orderStepType } = props

  const fieldName = `${orderStepType}.serviceTimeSec` as
    | 'pickup.serviceTimeSec'
    | 'delivery.serviceTimeSec'

  form.useAddFieldValidation<typeof fieldName>(fieldName, (field, _formApi) => {
    const serviceTimeSec = field.value

    if (serviceTimeSec === undefined || isNaN(serviceTimeSec)) {
      return OrderTexts.getValidationErrorServiceTimeText()
    }
  })

  return (
    <form.Fieldset>
      <form.SectionTitle variant="alternative">
        {OrderTexts.getServiceTimeTitle()}
      </form.SectionTitle>

      <Box width="50%">
        <form.DurationInput
          name={`${orderStepType}.serviceTimeSec`}
          label={OrderTexts.getFieldLabelServiceTimeText()}
          testId="serviceTime"
          durationFormat="hh:mm"
        />
      </Box>
    </form.Fieldset>
  )
}
